import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { base44 } from "@/api/base44Client";
import { VIATOR_SOURCE } from "@/lib/viator";

/**
 * The detail card's title bar: the place's own name on the left, the close
 * control on the right. The name comes from the record the card is showing, so
 * the visitor always knows which place they have open.
 */
export default function DetailOverlayHeader({ openId, openSource, closeRef, onClose }) {
  const [title, setTitle] = useState("");

  useEffect(() => {
    let live = true;
    setTitle("");
    const entity = openSource === VIATOR_SOURCE ? base44.entities.ViatorExperience : openSource === "hotel" ? base44.entities.RealEstateListing : openSource === "auto" ? base44.entities.AutoListing : base44.entities.Listing;
    entity
      .get(openId)
      .then((record) => live && setTitle(record?.name || record?.title || ""))
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [openId, openSource]);

  return (
    <div className="flex h-[60px] shrink-0 items-center justify-between gap-3 border-b border-white/[0.10] bg-black px-4 sm:px-6">
      <span
        id="detail-overlay-title"
        className="min-w-0 truncate text-[15px] font-extrabold uppercase tracking-[0.02em] text-white sm:text-[16px]"
      >
        {title}
      </span>
      <button
        ref={closeRef}
        onClick={onClose}
        type="button"
        aria-label="Close place details"
        className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/30 bg-[#1a1a1a] text-white transition-colors hover:bg-[#2a2a2a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-offset-2 focus-visible:ring-offset-black"
      >
        <X className="h-5 w-5 sm:h-[22px] sm:w-[22px]" strokeWidth={2.5} />
      </button>
    </div>
  );
}